import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return data.filter(d => d.vaxiom_person?.patient).map(d => d.vaxiom_person)
  }, [data])
}
